// extracted by mini-css-extract-plugin
export default {"tablet":"(max-width: 760px)","nav":"TestMockGlobalTopNav_nav__x7sng"};